export default require("./node_modules/@shaderfrog/glsl-parser/dist/index.js");